/**
 * 
 * @param {Number} number 
 */
export const num = (number)=>{
    return (typeof parseFloat(number) === "number" && parseFloat(number)>0) ?
        Number(number).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0;
}

/**
 * 
 * @param {String} p 
 */
export const Title = (p)=> {
	if(p.type==="Condominium") {
		return `CCT No. ${p.ctn}`;
	} else {
		if(p.registrationType==="tct") {
			return `TCT No. ${p.tct}`;
		}
		if(p.registrationType==="oct") {
			return `OCT No. ${p.oct}`;
		}
	}
}

/**
 * Add commas to value of currency, e.g. number_format
 * @param {Sring} value 
 */
export const Currency = (value)=>{
	return value
		.replace(/\D/g, "")
		.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * Return value of currency without the commas
 * @param {String} value 
 */
export const UnCurrency = (value)=>{
	return value
	.replace(/\D/g, "")
	.replace(/\B(?=(\d{3})+(?!\d))/g, "");
}

/**
 * 
 * @param {String} value 
 */
export const TinFormat = (value)=>{
	value = value || '';
	return value
		.replace(/\D/g, "")
		.replace(/\B(?=(\d{3})+(?!\d))/g, "-");
}

/**
 * 
 * @param {Array} subjs - Array of sellers, buyers
 * @param {String} noun (e.g. "seller", "buyer", etc.) 
 */
export const Noun = (subjs, noun) => {
	let u = subjs;
	let n = noun;
	let s = getMaritalStatus(u, 0, n);
	if(u.length>1 || s==="Married"){
		n = n+`s`
	}
	return n;
}

/**
 * 
 * @param {String} pronoun 
 * @param {String} gender 
 * @param {String} parties (sellers, buyers)
 * 
 */
export const Pronoun = (pronoun, gender, personality = null, parties = null) => {
	//console.log(personality+parties)
	let val="________";
	if(parties.toLowerCase()==="sellers" || parties.toLowerCase()==="buyers" || parties.toLocaleLowerCase()==="mortgagors" || parties.toLocaleLowerCase()==="mortgagees" || parties.toLocaleLowerCase()==="married" || parties.toLocaleLowerCase()==="borrowers"){
		if(pronoun==="he"){
			val = "they";
		}
		if(pronoun==="his"){
			val = "their";
		}
		if(pronoun==="him"){
			val = "them";
		}
		if(pronoun==="himself"){
			val = "themselves";
		}
		if(pronoun==="I"){
			val = "we";
		}
	} else {
		if(personality==="Natural Person"){
			if(pronoun==="he") {
				gender==="Male"?val="he":val="she";
			}
			if(pronoun==="his") {
				gender==="Male"?val="his":val="her";
			}
			if(pronoun==="him"){
				gender==="Male"?val="him":val="her";
			}
			if(pronoun==="himself"){
				gender==="Male"?val="himself":val="herself";
			}
			if(pronoun==="I"){
				val = "I";
			}
		} else {
			if(pronoun==="he"){
				val = "it";
			}
			if(pronoun==="his"){
				val = "its";
			}
			if(pronoun==="him"){
				val="it";
			}
			if(pronoun==="himself"){
				val = "itself";
			}
			if(pronoun==="I"){
				val = "we";
			}
		}
	}
	return val;
}

/**
 * 
 * @param {Array} user 
 * @param {Integer} i 
 * @param {String} noun 
 */
export const getMaritalStatus = (user, i, noun) => {
	let status = "Single"
	if(noun==="seller" && user[i].legalPersonality==="Natural Person"){
		status = user[i].sellerMaritalStatus;
	}
	if(noun==="buyer" && user[i].legalPersonality==="Natural Person"){
		status = user[i].buyerMaritalStatus;
	}
	if(noun==="mortgagor" && user[i].legalPersonality==="Natural Person"){
		status = user[i].mortgagorMaritalStatus;
	}
	if(noun==="mortgagee" && user[i].legalPersonality==="Natural Person"){
		status = user[i].mortgageeMaritalStatus;
	}
	if(noun==="borrower" && user[i].legalPersonality==="Natural Person"){
		status = user[i].borrowerMaritalStatus;
	}
	if(noun==="lendee" && user[i].legalPersonality==="Natural Person"){
		status = user[i].lendeeMaritalStatus;
	}
	return status;
}

/**
 * 
 * @param {Object} p1 - Seller, mortgagor 
 * @param {Object} p2 - Buyer, mortgagee
 */
export const FormRecommend = (p1, p2) => {
	let recom=[];

	let s = p1 || [];
	let b = p2 || [];
	let arr = [...s,...b];
	//console.log(arr)
	arr.forEach((u,i)=>{
		if(u.legalPersonality==="Natural Person"){
			if(u.sellerHasRepresentative==="Yes"){
				let obj1 = {
					form: "Special Power of Attorney (to sell)",
					path: "/contracts/free-contracts/special-power-of-attorney-to-sell"
				}
				if(recom.map(f=>f.form).indexOf("Special Power of Attorney (to sell)")===-1){
					recom.push(obj1);
				}
			}
		}
		if(u.legalPersonality==="Corporation"){
			let obj2 = {
				form: "Secretary's Certificate (to sell)",
				path: "/contracts/free-contracts/secretary-certificate-to-sell"
			}
			let obj3 = {
				form: "Board Resolution (to sell)",
				path: "/contracts/free-contracts/board-resolution-to-sell"
			}
			if(recom.map(f=>f.form).indexOf("Secretary's Certificate (to sell)")===-1){
				recom.push(obj2);
			}
			if(recom.map(f=>f.form).indexOf("Board Resolution (to sell)")===-1){
				recom.push(obj3);
			}
		}
	})
	return recom;
}

/**
 * 
 * @param {String} nationality 
 * @param {String} matiralStatus
 */
export const Nationality = (nationality, maritalStatus) => {
	if(nationality==="Filipino" || nationality==="filipino") {
		if(maritalStatus==="Married"){
			return nationality+"s";
		}
	}

	return nationality;
}

/**
 * 
 * @param {String} subject - sellers, buyers
 * @param {String} verb - must be in singular form
 * To fix has have subject-verd agreement
 */
export const SubjectVerb = (subject, verb) => {
	if(subject.toLowerCase()==="sellers" || subject.toLowerCase()==="buyers" || subject.toLocaleLowerCase()==="mortgagors" || subject.toLocaleLowerCase()==="mortgagees" || subject.toLocaleLowerCase()==="borrowers"){
		if(verb==="has"){
			return "have";
		}
		if(verb==="acknowledges"){ // acknowledges plural form
			return "acknowledge";
		}
		if(verb==="is"){
			return "are";
		}
		if(verb==="assures"){
			return "assure";
		}
	}
	return verb;
}

export const SingularPluralForm = (parties, word) => {
	//console.log(parties.toLocaleLowerCase())
	if(parties.toLowerCase()==="sellers" || parties.toLowerCase()==="buyers" || parties.toLocaleLowerCase()==="mortgagors" || parties.toLocaleLowerCase()==="mortgagees"){
		return word;
	}
	return word+`s`;
}



// WEBPACK FOOTER //
// ./src/model/Helper.js